// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status[data-v-6bfa8dec]{font-size:12.5rem;line-height:1;margin-top:10svh}div[data-v-6bfa8dec]{text-align:center}h1[data-v-6bfa8dec]{font-size:1.875rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
